import React, { Component } from 'react'

import { Form, Field } from 'redux-form'
import { Input } from 'components/Input/Input'
import Radio from 'components/Input/Radio'
import Button from 'components/Button'
import FileInput from 'features/Files/FileInput'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import {
  vRequired,
  vFileRequired,
  v1300Number,
  v1800Number,
} from 'components/Input/Input.validations'

export default ({ prev, formData, numberType }) => (
  <div>
    <div className={cn(sText.descrip3, sMarg.mb30)}>
      Tell us what Telco company that's with? If any, but your active number should be linked to an
      existing telco plan with a company like Optus, Telstra, TPG etc. Please Note: Inactive numbers
      are not linked to a telco plan and usually purchased through 'The Numbering System'. If this
      is you, then you need to select the Inactive option.
    </div>
    <Field
      label="I have an Active number"
      component={Radio}
      name="isExistingNumberInActive"
      radioValue={false}
      style={{ marginBottom: '15px' }}
    />
    <Field
      label="I have an Inactive number"
      component={Radio}
      name="isExistingNumberInActive"
      radioValue
    />
    <div className={cn(sText.descrip3, sMarg.mv30)}>
      {formData.isExistingNumberInActive
        ? `Inactive numbers are not linked to an active ${numberType} account with any telco. We need proof that you own this number before we can link it to your new Pickle account.`
        : 'We need to know the name and account number of your current telco so we can arrange for your number to be connected. You should be able to find your account number on a recent phone bill.'}
    </div>
    <Field
      label={`Existing ${numberType} Number`}
      component={Input}
      info="This is the number you want to activate on this plan."
      name="number"
      type="number"
      validate={[vRequired, numberType === '1300' ? v1300Number : v1800Number]}
    />
    {formData.isExistingNumberInActive ? (
      <Field
        label="EROU Proof of Purchase"
        info="Attach the purchase confirmation email or invoice so we can verify you own this number."
        component={FileInput}
        name="proofOfPurchase"
        validate={[vFileRequired]}
      />
    ) : (
      <div>
        <Field
          label="Existing Number Provider"
          component={Input}
          info="Which telco sold you this number? (eg Telstra, Optus, TPG etc)"
          name="existingNumberProvider"
          validate={[vRequired]}
        />
        <Field
          label="Existing Account Number"
          info="What is your account number with the telco above?"
          component={Input}
          name="existingNumberAccount"
          validate={[vRequired]}
        />
      </div>
    )}
    <div className={cn(sText.descrip5, sMarg.mt30)}>
      {formData.isExistingNumberInActive ? (
        <p>
          I warrant that if my Inbound Service number is an EROU Number, I am the Rights of Use
          holder for that Number (as shown on the ACMA Rights of Use Register) or that I otherwise
          have the rights to use the EROU Number with my Inbound Service.
        </p>
      ) : (
        <div>
          <p>
            I warrant that the details I have completed in this form are correct and that the
            Customer specified above is the legal lessee of the Inbound Service associated with the
            Inbound Service number and account number provided by the current Service Provider
            specified above.
          </p>
          <p>
            I request and authorise Pickle to arrange for the cancellation of my Inbound Service
            provided by my current Service Provider and the porting of my Inbound Service number
            listed above from my current Service Provider to Pickle.
          </p>
          <p>
            I acknowledge that if my current Inbound Service is successfully ported to Pickle, my
            Inbound Service will be provided by Pickle subject to the terms and conditions of the
            Inbound Services section of Our Customer Terms.
          </p>
        </div>
      )}
    </div>
    <div
      className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
      style={{ marginTop: '40px' }}
    >
      <Button color="tertiary" type="submit">
        Next
      </Button>
      <br />
      <br />
      <Button plain onClick={prev}>
        Back
      </Button>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersTransferExistingStep/NumbersTransferExisting.jsx